import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import { set } from '@ember/object';

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — pure redirect: `/private` immediately transitions to `list`
 *              filtered by `type=private`. Legacy/bookmarked-URL compatibility shim.
 *   extends:   Route (@ember/routing/route)
 *   template:  none
 *   model:     - (redirects in beforeModel before any model hook runs)
 *   key:       beforeModel (the redirect), setupController (chrome collapse, runs on
 *              the brief pass-through before the transition completes)
 *   uses:      router (@service)
 *   siblings:  routes/list (redirect target, not in this file set)
 *   tests:     simple-routes-test.js ("private route redirects to the list route
 *              filtered by type=private", "private route still collapses the chrome
 *              when set up")
 *   gotchas:   -
 *
 * Redirect-only route: `/private` → `list?type=private`.
 */
export default class PrivateRoute extends Route {
  @service router;

  setupController(controller, model) {
    super.setupController(controller, model);
    const application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
  }

  beforeModel(/*transition*/) {
    this.router.transitionTo('list', {
      queryParams: {
        type: 'private',
      },
    });
  }
}
